module.exports = __webpack_public_path__ + "static/fonts/BMJUA.7dbe95a.ttf";